import { render, staticRenderFns } from "./shopping.vue?vue&type=template&id=55b519c0&"
import script from "./shopping.vue?vue&type=script&lang=js&"
export * from "./shopping.vue?vue&type=script&lang=js&"
import style0 from "./shopping.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports